import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BlockIcon from "@mui/icons-material/Block";

function Unauthorized() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 420,
          textAlign: "center",
          borderRadius: 3,
        }}
      >
        <BlockIcon color="error" sx={{ fontSize: 64, mb: 2 }} />

        <Typography variant="h5" sx={{ fontWeight: "bold", mb: 1 }}>
          ไม่สามารถเข้าถึงหน้านี้ได้
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          คุณไม่มีสิทธิ์เข้าใช้งานหน้านี้
          <br />
          กรุณาติดต่อผู้ดูแลระบบ หากคิดว่าเป็นความผิดพลาด
        </Typography>

        <Button
          variant="contained"
          onClick={() => navigate("/")}
          fullWidth
        >
          กลับไปหน้าแรก
        </Button>
      </Paper>
    </Box>
  );
}

export default Unauthorized;
